import React, { Component } from 'react';
import couterpart from 'counterpart';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import Dialog from 'react-bootstrap-dialog';
import { FaFilter, FaEdit } from 'react-icons/fa';

import MenuComponent2 from './MenuComponent2';
import WorkOrderDataService from '../services/WorkOrderDataService';
import WorkOrderImages from './WorkOrderImages';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import AuthenticationService from '../services/AuthenticationService';
import queryString from 'query-string'
import MasterDataService from '../services/MasterDataService';

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

import '../css/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import { ICON_COLOR } from '../icon';
import { EVENT_NAME_CHANGE_WO_STATUS, EVENT_NAME_REPORT_WO_KIM, WO_BONG, WO_HOANTHANH, WO_QUAYKIM, WO_TOBE_FIXED } from '../constants';
import ItemDetailsViewById from './ItemDetailsViewById';


class KimScan extends Component {
    constructor() {
        super();
        this.state = {
            allStatus: [],
            workOrder: {},
            workOrderId: null,
            updated: false,
            options: "",
            status: 0,
            inputOrderNo: '',
            inputPCode: '',
            show: false,
            show2: false,
            show3: false,
            selectedError: 0,
            selectedErrorDesc: '',
            errorCodes: [
                { id: 0, name: '' },
                { id: 1, name: 'Cắt/Khắc sai TK', mapTo: 54 },
                { id: 2, name: 'TK sai, trả về TK', mapTo: 32 },
                { id: 3, name: 'Sai size', mapTo: 54 },
                { id: 4, name: 'Sai kỹ thuật', mapTo: 54 },
                { id: 5, name: 'Cắt khắc sai', mapTo: 54 },
                { id: 6, name: 'Bạc dộp', mapTo: 54 },
                { id: 7, name: 'Quay kim không đủ, không đều', mapTo: 54 },
                { id: 8, name: 'xước, mẻ, lỗ bề mặt', mapTo: 54 },
                { id: 9, name: 'Lỗi Xi xi lại', mapTo: 54 },
                { id: 14, name: 'Lỗi Xi đánh lại', mapTo: 54 },
                { id: 10, name: 'Lỗi khác', mapTo: 54 },
                { id: 13, name: 'Lỗi khác (Thợ)', mapTo: 54 },
            ],
            shipErrors: [],
            filterErrorsByFunc: [],
            errorGroups: []
        };
        this.scanInput = React.createRef();
    };

    componentDidMount() {

        const query = queryString.parse(this.props.location.search);
        if (query.caller === '0') { //Clicked on NAV
            WorkOrderUtil.removeItem("kimWo.woNo");
        }

        MasterDataService.retrieveAllStatus().then(data => {
            this.setState({ allStatus: data })
        });

        MasterDataService.retrieveShippingMasterErrors().then(data => {
            this.setState({ 
                shipErrors:  data
            });
        });

        MasterDataService.retrieveErrorUis('KM').then(data => {
            console.log('retrieveErrorUis: ', data);
            this.setState({ 
                errorsByFunc:  data
            });
        });

        this.loadErrorGroups();
    }

    loadErrorGroups() {
        MasterDataService.retrieveErrorGroups('KM').then(data => {
        let len = data.length;
        let errorGroups = [];
        for (let i = 0; i < len; i++) {
            errorGroups.push({ key: data[i].key, value: data[i].value })
        }
        this.setState({ errorGroups: errorGroups });
        });
    }

    getCurrentStatus(status) {
        if (this.state.allStatus === undefined || this.state.allStatus.length < 1) {
            return status;
        }

        let currentStatus = this.state.allStatus.find(x => {
            return x.status === status;
        });
        return currentStatus ? currentStatus.statusDescVn : status;
    }

    renderOption(option) {
        return (
            <option key={option.key} value={option.value}>{option.label}</option>
        );
    }

    renderWorkerByRole() {
        if (!AuthenticationService.isAdmin()) {
            return (<label>{this.state.workOrder.workerFullName}</label>);
        }

        if ((this.state.selectOptions === undefined) || (this.state.selectOptions === null)) {
            return (<></>);
        }
        return (
            <select defaultValue={this.state.workOrder.worker} onChange={this.handleSelectChange.bind(this)}>
                {this.state.selectOptions !== undefined && this.state.selectOptions.map(option => this.renderOption(option))}
            </select>
        );
    }

    handleOrderNoChange(e) {
        var value = e.target.value;
        sessionStorage.setItem("scanWorkOrder.inputOrderNo", value)
        this.setState(prevState => ({
            inputOrderNo: value
        }));
    }

    handlePCodeChange(e) {
        var value = e.target.value;
        sessionStorage.setItem("scanWorkOrder.inputPCode", value)
        this.setState(prevState => ({
            inputPCode: value
        }));
    }

    filterWorkOrdersByNoForKim() {
        var no = this.state.orderNo;
        if (no === undefined || no === null || no.trim().length < 1) {
            return;
        }

        WorkOrderDataService.scanByNo(`${no}`).then(data => {
            let showMe = false;
            if (data.status !== WO_BONG && data.status !== WO_HOANTHANH && data.status !== WO_TOBE_FIXED) {
                showMe = false;
                alert(couterpart.translate('work_order_invalid_status_bong'));
            } else {
                showMe = true;
            }
            this.setState({
                workOrderId: data.id,
                workOrder: data,
                updated: true,
                show: showMe
            });
        });
    }

    filterWorkOrdersByPCodeForKim() {
        var pCode = this.state.pCode;
        if (pCode === undefined || pCode === null || pCode.trim().length < 1) {
            return;
        }

        WorkOrderDataService.scanByPCode(`${pCode}`).then(data => {
            let showMe = false;
            if (data.status !== WO_BONG && data.status !== WO_HOANTHANH && data.status !== WO_TOBE_FIXED) {
                showMe = false;
                alert(couterpart.translate('work_order_invalid_status_bong'));
            } else {
                showMe = true;
            }
            this.setState({
                workOrderId: data.id,
                workOrder: data,
                updated: true,
                show: showMe
            });
        });
    }

    processOrder() {
        let orderNo = this.state.inputOrderNo;

        if (orderNo !== undefined && orderNo !== null && orderNo.trim().length > 0) {
            this.setState({
                workOrderId: 0,
                workOrder: {},
                show: false,
                updated: false,
                orderNo: orderNo,
                pCode: ''
            }, () => {
                if (this.state.orderNo !== undefined && this.state.orderNo.trim().length > 0) {
                    this.filterWorkOrdersByNoForKim()
                }
            });
        } else {
            let pCode = this.state.inputPCode;
            if (pCode !== undefined && pCode !== null && pCode.trim().length > 0) {
                this.setState({
                    workOrderId: 0,
                    workOrder: {},
                    show: false,
                    updated: false,
                    orderNo: '',
                    pCode: pCode
                }, () => {
                    if (this.state.pCode !== undefined && this.state.pCode.trim().length > 0) {
                        this.filterWorkOrdersByPCodeForKim()
                    }
                });
            }
        }
    }

    handleKeyDown(e) {
        if (e.key === 'Enter') {
            this.processOrder()
        }
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleClose() {
        this.setState({ show: false, inputOrderNo: '' },
            () => {
                this.sleep(500).then(() => {
                    this.scanWorkOrderNo.focus();
                })
            });
    }

    handleClose2() {
        this.setState({ show2: false },
            () => {
                this.sleep(500).then(() => {
                    this.scanWorkOrderNo.focus();
                })
            });
    }

    handleClose3() {
        this.setState({ show3: false },
            () => {
                this.sleep(500).then(() => {
                    this.scanWorkOrderNo.focus();
                })
            });
    }

    renderErrorOption(error) {
        return (
            <option key={error.id} value={error.id}>{error.name}</option>
        );
    }

    renderErrors() {
        return (
            <select onChange={this.handleErrorChange.bind(this)}>
                {this.state.errorCodes !== undefined && this.state.errorCodes.map(error => this.renderErrorOption(error))}
            </select>
        );
    }

    renderErrorByFuncOption(error){
        return (
            <option key={error.errorCode} value={error.errorCode}>{error.errorCode} - {error.errorName}</option>
        );
    }

    renderErrorsByFunc(){
        return(
        <select onChange={this.handleErrorChangeNew.bind(this)} className= "inputBox3">
        {this.state.filterErrorsByFunc !== undefined && this.state.filterErrorsByFunc.map(error =>this.renderErrorByFuncOption(error))}
        </select>
        );
    }

    getErrorDesc(id) {
        let err = this.state.errorCodes.find(it => {
            return it.id == id
        })
        if (err) {
            return err.name;
        }
        return id;
    }

    handleErrorChange(e) {
        var value = e.target[e.target.selectedIndex].value;
        let mapStatus = 0;
        if (value == 2) {
            mapStatus = 32;
        } else {
            mapStatus = 54;
        }
        console.log('mapStatus', mapStatus)

        let desc = this.getErrorDesc(value);
        this.setState({
            selectedError: value,
            selectedErrorDesc: desc,
            status: mapStatus
        });
    }

    handleErrorChangeNew(e){
        var value = e.target[e.target.selectedIndex].value;
        let mapStatus = 0;
        let err = this.state.errorsByFunc.filter(e => {
            return e.errorCode === value;
        });
        console.log('Err', err);

        if (err === undefined || err === null || err.length <= 0){
            return;
        }
        let desc = err[0].errorName;
        mapStatus = err[0].mappingStatus;
        console.log('mapStatus', mapStatus);
        this.setState({               
            selectedError: value,
            selectedErrorDesc: desc,
            status: mapStatus              
        });
    }

    handleEdit(wo) {
        this.setState({
            workOrderId: 0,
            workOrder: {},
            show: false,
            updated: false,
            inputOrderNo: wo.workOrderNo,
            orderNo: wo.workOrderNo
        }, () => {
            if (this.state.orderNo !== undefined && this.state.orderNo.trim().length > 0) {
                this.filterWorkOrdersByNoForKim()
            }
        });
    }

    changeWorkOrderToKim() {
        if (this.state.workOrder.status === WO_QUAYKIM) {
            alert(couterpart.translate('work_order_status_already_existed'));
            return;
        }

        console.log('WO', this.state.workOrder);

        if (this.state.workOrder.status != WO_BONG && this.state.workOrder.status !== WO_HOANTHANH && this.state.workOrder.status != WO_TOBE_FIXED) {
            alert(couterpart.translate('work_order_invalid_status'));
            return;
        }

        let wo = JSON.parse(JSON.stringify(this.state.workOrder))
        wo.status = WO_QUAYKIM;
        wo.eventName = AuthenticationService.getRole() + "_" + EVENT_NAME_CHANGE_WO_STATUS;
        this.setState({
            workOrder: wo,
            inputOrderNo: ''
        }, () => {
            WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                if (data.updated === 0) {
                    this.setState({
                        workOrder: {},
                        inputOrderNo: ''
                    });
                }
                this.handleClose();
            });
        });
    }

    changeWorkOrderToKiemTra() {
        let ret = window.confirm(couterpart.translate('msg_wait_vck_change_confirm'));
        let selectedItems = [this.state.workOrder.id];
        if (ret === true) {
            WorkOrderDataService.changeToKiemTra(selectedItems).then(data => {
                if (data.message === undefined) {
                    this.filterWorkOrdersByNoForKim()
                }
            });
        }
    }

    renderShipto(){
        if(this.state.workOrder.shipTo === 'Úc'){
            return (
                <div className="col-6 border-top border-left border-right border-light-gray" style={{ backgroundColor:'green' }}><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.shipTo}</label></div>
            );
        }
        
        return (
            <div className="col-6 border-top border-left border-right border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.shipTo}</label></div>
        );                
    }

    renderColor(){
        if(this.state.workOrder.colorMaterial === undefined || this.state.workOrder.colorMaterial === null){
            return (
                <div className="col-3 border-top border-left border-right border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.colorMaterial}</label></div>
            );
        }
        if ((this.state.workOrder.colorMaterial.toUpperCase() === 'VÀNG') || (this.state.workOrder.colorMaterial.toUpperCase() === 'MÀU VÀNG')){
            return (
                <div className="col-3 border-top border-left border-right border-light-gray" style={{ backgroundColor:'yellow' }}><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.colorMaterial}</label></div>
            );
        }

        if ((this.state.workOrder.colorMaterial.toUpperCase() === 'HỒNG') || (this.state.workOrder.colorMaterial.toUpperCase() === 'MÀU HỒNG')){
            return (
                <div className="col-3 border-top border-left border-right border-light-gray" style={{ backgroundColor:'pink' }}><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.colorMaterial}</label></div>
            );
        }

        if ((this.state.workOrder.colorMaterial.toUpperCase() === 'BẠC') || (this.state.workOrder.colorMaterial.toUpperCase() === 'MÀU BẠC')){
            return (
                <div className="col-3 border-top border-left border-right border-light-gray" style={{ backgroundColor:'grey' }}><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.colorMaterial}</label></div>
            );
        }
        
        return (
            <div className="col-3 border-top border-left border-right border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.colorMaterial}</label></div>
        );                
    }

    getGhiLoi(code){
        if (this.state.shipErrors === undefined || this.state.shipErrors.length < 1){
            return code;
        }

        let codeDesc = this.state.shipErrors.find(x => {
            return x.errorCode === code;
        });
        return codeDesc? codeDesc.errorName : code;
    } 


    renderDetails() {
        if (this.state.workOrder.workOrderNo === undefined) {
            return (<div>&nbsp;
            </div>)
        }

        return (
            <div>
                <div className="row">
                    <div className="col-8">
                        <div className="row">
                            <div className="col-4 border-top border-left border-light-gray">
                                <div className="row"><img alt="" src={"data:image/gif;base64," + this.state.workOrder.qrCode} /></div>
                                <div className="row">
                                    <label className="label_link" onClick={this.handleEdit.bind(this, this.state.workOrder)}> {this.state.workOrder.workOrderNo} </label>
                                </div>
                            </div>
                            <div className="col-8 border-top border-left border-light-gray">
                                <div className="row border-bottom border-light-gray">
                                    <div className="col"><b>{couterpart.translate('work_order_order_date_s')}</b></div>
                                    <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.orderDate)}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">
                                    <div className="col"><b>{couterpart.translate('work_order_leadTimeProduction')}</b></div>
                                    <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.leadTimeProduction)}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">
                                    <div className="col"><b>{couterpart.translate('work_order_worker')}</b></div>
                                    <div className="col border-left border-right border-light-gray">{this.renderWorkerByRole()}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">
                                    <div className="col"><b>{couterpart.translate('work_order_end_date')}</b></div>
                                    <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.prodDeadlineTs)}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">
                                    <div className="col">
                                        <label className="labelBox">{couterpart.translate('work_ngay_nhap_lieu')}</label>
                                    </div>
                                    <div className="col border-left border-right border-light-gray">
                                        <label className="labelValueBox">{
                                            WorkOrderUtil.formatShortDisplayDateMMddyyyy3(this.state.workOrder.ngayNhapLieu)
                                        }</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_code')}</b></div>
                            <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.sku}</div>
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('shop_pcode')}</b></div>
                            <div className="col-2 border-top border-left border-light-gray">{this.state.workOrder.fullPCode}</div>
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_color')}</b></div>
                                {
                                    this.renderColor()
                                }
                        </div>
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_type')}</b></div>
                            <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.shapeDesign}</div>
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_quantity_s')}</b></div>
                            <div className="col-2 border-top border-left border-light-gray">{this.state.workOrder.qty}</div>
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_size')}</b></div>
                            <div className="col-3 border-top border-left border-right border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px' }}>{this.state.workOrder.lengthSize}</label></div>
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_font')}</b></div>
                            <div className="col-5 border-top border-left border-light-gray"><pre>{this.state.workOrder.font}</pre></div>
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_personalization')}</b></div>
                            <div className="col-3 border-top border-left border-right border-light-gray"><pre style={{ 'fontSize': '20px' }}>{this.state.workOrder.personalization}</pre></div>
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_urgent_level')}</b></div>
                            <div className="col-2 border-top border-left border-light-gray">
                                <label style={{'fontSize': '20px', color:'red', margin: '2px'}}>{ this.state.workOrder.isUrgentByCustomer === 1 ? 'X' : ''}</label>
                            </div>
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_shipto')}</b></div>
                            { this.renderShipto() }
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_special_note')}</b></div>
                            <div className="col-10 border-top border-left border-right border-light-gray">{this.state.workOrder.notesInternal}</div>
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray">
                                <b>{couterpart.translate('work_order_ycdb_shipping')}</b>
                            </div>
                            <div className="col-10 border-top border-left border-right border-light-gray">
                                {this.state.workOrder.ycdbShipping? this.state.workOrder.ycdbShipping : ''}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_status')}</b></div>
                            <div className="col-2 border-top border-left border-right border-light-gray">{this.getCurrentStatus(this.state.workOrder.status)}</div>
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_shipping_note')}</b></div>
                            <div className="col-6 border-top border-left border-right border-light-gray">{this.state.workOrder.shippingNote}</div>
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">{ couterpart.translate('work_order_itype') }</label>
                            </div>                            
                            <div className="col-10 border-top border-left border-right border-light-gray">
                                { WorkOrderUtil.getItemTypeDescription(this.state.workOrder.itemType) }
                            </div>                            
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">
                                    { couterpart.translate('work_order_status_len') }
                                </label>
                            </div>
                            <div className="col-10 border-top border-left border-right border-light-gray">
                                { WorkOrderUtil.getLenStatusDescription2(this.state.workOrder) }
                            </div>
                        </div> 
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray">
                                <label className="labelBox">
                                    { couterpart.translate('work_order_status_da') }
                                </label>
                            </div>
                            <div className="col-10 border-top border-left border-right border-light-gray">
                                { WorkOrderUtil.getDaStatusDescription2(this.state.workOrder) }
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-2 border-top border-left border-bottom border-light-gray'>
                                <label className="labelBox">
                                    { couterpart.translate('work_order_ship_with_error') }
                                </label>
                            </div>
                            <div className='col-10 border-top border-left border-right border-bottom border-light-gray'>
                                <label style={{color:'brown'}}>{ this.getGhiLoi(this.state.workOrder.category) }</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <button className="myBigButton" onClick={this.changeWorkOrderToKiemTra.bind(this)}>
                                    <FaEdit color={ICON_COLOR} />
                                    &nbsp;{couterpart.translate('button_kt')}</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-4">
                        <WorkOrderImages mode="MODE_EDIT" workOrderId={this.state.workOrderId} largeMode={1}
                            isUpdated={this.state.updated} />
                        <div className="row">&nbsp;</div>
                        <div className="row" style={{ margin: "1px"}}>
                            <ItemDetailsViewById itemSku={this.state.workOrder.sku}/>
                        </div>            
                    </div>
                </div>
                <Dialog ref={(component) => { this.dialog = component }} />
                <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{couterpart.translate('lbl_caption_update')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-6">
                                <span>{couterpart.translate('work_order_no')} : </span>
                            </div>
                            <div className="col-4">
                                {this.state.workOrder.workOrderNo}
                            </div>
                            <div className="col-6">
                                <span>{couterpart.translate('shop_pcode')} : </span>
                            </div>
                            <div className="col-4">
                                {this.state.workOrder.fullPCode}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        {<Button variant="primary" onClick={this.changeWorkOrderToKim.bind(this)}>{couterpart.translate('button_continue')}</Button>}
                        {<Button variant="primary" onClick={this.onLoiClicked.bind(this)}>{couterpart.translate('button_error')}</Button>}
                        {<Button variant="primary" onClick={this.handleClose.bind(this)}>{couterpart.translate('button_cancel')}</Button>}
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.show3} onHide={this.handleClose3.bind(this)} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{couterpart.translate("msg_title_confirm")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                            <div className="col-6">
                                {this.renderErrorGroups()}
                            </div>
                            <div className="col-6">
                                {this.renderErrorsByFunc()}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <input type="text" name="shippingNote" className="inputBox3Fix" placeholder={couterpart.translate('label_note')}
                                    onChange={this.handleKimNoteChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleKimNoteChange(e) }, 0); }} />
                            </div>
                        </div>
                        <div className="row">&nbsp;</div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleClose3.bind(this)}>Cancel</Button>
                        <Button variant="primary" onClick={this.onLoiOKClicked.bind(this)}>OK</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }

    handleKimNoteChange(e) {
        let vl = e.target.value
        this.setState(prevState => ({
            workOrder: {
                ...prevState.workOrder
            },
            shippingNote: vl
        }));
    }

    handleChangeStatus(act) {
    }

    onLoiClicked() {
        this.setState({
            show3: true,
            shippingNote: ''
        });
    }

    onLoiOKClicked() {
        this.dialog.show({
            title: couterpart.translate("msg_title_confirm"),
            body: couterpart.translate("msg_change_confirm"),
            actions: [
                Dialog.CancelAction(),
                Dialog.OKAction(() => {
                    let wo = JSON.parse(JSON.stringify(this.state.workOrder))
                    let note = this.state.shippingNote ? ': ' + this.state.shippingNote : '';
                    wo.status = this.state.status;
                    wo.errorCode = this.state.selectedError;
                    if (wo.errorCode == 9) { //Loi xi
                        wo.errorCount = wo.errorCount + 1;
                    }
                    wo.shippingNote = this.state.selectedErrorDesc + note;
                    wo.eventName = AuthenticationService.getRole() + "_" + EVENT_NAME_REPORT_WO_KIM;
                    this.setState({
                        workOrder: wo,
                        inputOrderNo: '',
                        action: 1,
                        show3: false
                    }, () => {
                        WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                            this.handleClose();
                        });
                    });
                })
            ],
            bsSize: 'small',
            onHide: (dialog) => {
                dialog.hide()
                console.log('closed by clicking background.')
            }
        });
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    selectDefaultError(err){
        if (err === undefined || err === null){
            return;
        }
        let desc = err.errorName;
        let mapStatus = err.mappingStatus;
        this.setState({               
            selectedError: err.errorCode,
            selectedErrorDesc: desc,
            status: mapStatus              
        });
    }

    handleErrorGroupSelectChange(e){
        let value = e.target[e.target.selectedIndex].value;
        this.setState({
            selectedErrorGroup: value
        }, () => {
            let errs = this.state.errorsByFunc.filter(e => {
                return e.errorCode.indexOf(this.state.selectedErrorGroup) === 0;
            });
            console.log('Errs', errs);
            this.setState({filterErrorsByFunc: errs }, () => {
                this.selectDefaultError(errs[0]);
            });
        });
    };

    renderErrorGroupOption(option){
        return (
            <option key={option.key} value={option.key}>{option.key + " - " + option.value}</option>
        );
    }

    renderErrorGroups(){
        if(this.state.errorGroups === undefined){
            return (<></>);
        }
        return(
        <>
        <select onChange={this.handleErrorGroupSelectChange.bind(this)} className="inputBox3" >
            <option key="" value=""></option>
            {this.state.errorGroups !== undefined && this.state.errorGroups.map(option =>this.renderErrorGroupOption(option))}
        </select>&nbsp;&nbsp;
        </>
        );
    }


    render() {
        if (!AuthenticationService.isKim()) {
            return (<div>Unauthorized access.</div>);
        }

        return (
            <div>
                <MenuComponent2 />
                <ToastsContainer store={ToastsStore} position="bottom_center" />
                <div className="row" style={{ margin: "10px" }}>
                    <div className="col-2">
                        <input type="text" value={this.state.inputOrderNo} style={{ margin: "5px" }}
                            name="scanWorkOrderNo" id="scanWorkOrderNo" autoFocus ref={input => this.scanWorkOrderNo = input}
                            placeholder={couterpart.translate('order_no')}
                            onChange={this.handleOrderNoChange.bind(this)} onKeyDown={this.handleKeyDown.bind(this)} />
                    </div>
                    <div className="col-2">
                        <input type="text" value={this.state.inputPCode} style={{ margin: "5px" }}
                            name="scanPCode" id="scanPCode"
                            placeholder={couterpart.translate('shop_pcode')}
                            onChange={this.handlePCodeChange.bind(this)} onKeyDown={this.handleKeyDown.bind(this)} />
                    </div>
                    <div className="col-1">
                        <button className="myButton" onClick={this.processOrder.bind(this)}>
                            <FaFilter color={ICON_COLOR} />
                            &nbsp;{couterpart.translate('button_filter')}</button>
                    </div>
                </div>
                <div className="row" style={{ margin: "5px" }}>
                    <div className="col-12">
                        {this.renderDetails()}
                    </div>
                </div>
            </div>
        );
    }
}

export default KimScan;